"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./directive"));
__export(require("./validator"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/ng2-validation/dist/phone/index.js
// module id = ../../../../ng2-validation/dist/phone/index.js
// module chunks = 42